import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/category/page', data, {
    trim: true
  })
}
export function allList (data) {
  return request.post('/business/category/list', data, {
    trim: true
  })
}
export function treeList (data) {
  return request.post('/business/category/tree', data, {
    trim: true
  })
}
// 导出Excel
export function exportExcel (data) {
  return request.post('/business/category/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/category/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/category/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/category/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/category/delete/batch', {
    params: {
      ids
    }
  })
}
